import type { MonitorStage } from "./types";

/** Union observed intervals; overlapping scene work is counted once. */
export function groupStats(stages: MonitorStage[], asOf: string) {
  const intervals: [number, number][] = [];
  const states: Record<string, number> = {};
  let incomplete = false;
  for (const stage of stages) {
    states[stage.state] = (states[stage.state] ?? 0) + 1;
    const start = Date.parse(stage.started_at ?? "");
    const end = Date.parse(stage.finished_at ?? asOf);
    if (!Number.isFinite(start) || !Number.isFinite(end) || end < start) {
      incomplete = true;
      continue;
    }
    intervals.push([start, end]);
  }
  intervals.sort((a, b) => a[0] - b[0]);
  let total = 0;
  let end = -Infinity;
  for (const [start, finish] of intervals) {
    total += Math.max(0, finish - Math.max(start, end));
    end = Math.max(end, finish);
  }
  return {
    states,
    incomplete,
    startedAt: intervals[0]
      ? new Date(intervals[0][0]).toISOString()
      : undefined,
    observedWallMs: intervals.length ? total : null,
    inputs: [...new Set(stages.flatMap((stage) => stage.input_refs))],
  };
}
